export const isIndividualClickLimitPresent = (
  individualClickLimit: number | null,
  isCampaignClickLimitPerUser: boolean,
  campaignClickLimit?: number,
): boolean => {
  // click limit was manually removed
  if (individualClickLimit === 0) {
    return false
  }

  // click limit was set for the person
  if (individualClickLimit !== null) {
    return true
  }

  // click limit was set for each participant of campaign individually
  if (campaignClickLimit && isCampaignClickLimitPerUser) {
    return true
  }

  return false
}
